module.exports = __webpack_public_path__ + "img/minecart-loaded.74b678ba.svg";